import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'core/api/api.service';
import { EnsNotification } from '../entities/ens-notification.class';

@Injectable({
  providedIn: 'root'
})
export class EmailNotificationService {

  private notificationBaseUrl = '/api/emailNotification';
  private listByQuoteUrl = `${this.notificationBaseUrl}/list`;
  private listByCustomerUrl = `${this.notificationBaseUrl}/listByCustomer`;
  private notificationEditUrl = `${this.notificationBaseUrl}/create/edit`;
  private amEmailUrl = '/api/accountManager/email';

  constructor(
    private apiService: ApiService,
  ) { }

  getNotificationsByQuote(quoteId: string): Observable<EnsNotification[]> {
    return this.apiService.get(`${this.listByQuoteUrl}/${quoteId}`);
  }

  getNotificationsByCustomer(customerId: string): Observable<EnsNotification[]> {
    return this.apiService.get(`${this.listByCustomerUrl}/${customerId}`);
  }

  getAccountManagerEmail(accountManagerId: string): Promise<{email: string}> {
    return this.apiService.get(`${this.amEmailUrl}/${accountManagerId}`).toPromise();
  }

  updateEnsNotifications(quoteId: string, customerId: string, notifications: EnsNotification[]): Observable<EnsNotification[]> {
    return this.apiService.post(this.notificationEditUrl, {
      quoteId,
      customerId,
      emailNotifications: notifications
    });
  }
}
